import { render } from "./VotesListPage.vue?vue&type=template&id=041ea2ae"
import script from "./VotesListPage.vue?vue&type=script&lang=js"
export * from "./VotesListPage.vue?vue&type=script&lang=js"

import "./VotesListPage.vue?vue&type=style&index=0&id=041ea2ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__